import React from "react";
import { connect as connectFormik } from 'formik';
import { withLocalize, Translate } from "react-localize-redux";
import BbCheckbox from "../../styling/bbCheckbox";
import BbInput from '../../styling/bbInput';
import { unicornCountry } from "../../../store/marketingListStore";

const style = { padding: "0 0.75em", minHeight: "3em" }

class TimeSeries extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="columns">
                    <div className="column bb-input-label-column" style={{ ...style }}>
                        <div className="bb-radio-group-wrapper">
                            <div className="bb-radio-group-row">
                                <div className="control">
                                    <Translate id="Search.Marketing.LastX" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="column bb-input-column is-8" style={style}>
                        <div className="control">
                            <BbInput
                                name="timeSeries.lastX"
                                type="number"
                                min={1}
                                max={10}
                                placeholder={{ type: 'inline' }}
                                style={{ paddingLeft: "0", paddingRight: "0" }}
                                label=""
                            />
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="column is-6">
                        <BbCheckbox label={this.props.translate("MarketingList.TimeSeries.TurnoverCategory")} value={this.props.formik.values.timeSeries.turnoverCategory} id="turnoverCategory" onChange={c => this.props.formik.setFieldValue('timeSeries.turnoverCategory', c)} />
                        <BbCheckbox label={this.props.translate("Search.Common.RegisteredCapital")} value={this.props.formik.values.timeSeries.registeredCapital} id="registeredCapital" onChange={c => this.props.formik.setFieldValue('timeSeries.registeredCapital', c)} />
                        <BbCheckbox label={this.props.translate("MarketingList.TimeSeries.MainNace")} value={this.props.formik.values.timeSeries.mainNace} id="mainNace" onChange={c => this.props.formik.setFieldValue('timeSeries.mainNace', c)} />
                        {unicornCountry() === 'sk' && <BbCheckbox label={this.props.translate("MarketingList.TimeSeries.MainNaceRuz")} value={this.props.formik.values.timeSeries.mainNaceRuz} id="mainNaceRuz" onChange={c => this.props.formik.setFieldValue('timeSeries.mainNaceRuz', c)} />}
                    </div>
                    <div className="column is-6">
                        <BbCheckbox label={this.props.translate("MarketingList.TimeSeries.EmployeesCategory")} value={this.props.formik.values.timeSeries.employeesCategory} id="employeesCategory" onChange={c => this.props.formik.setFieldValue('timeSeries.employeesCategory', c)} />
                        <BbCheckbox label={this.props.translate("MarketingList.TimeSeries.EmployeesCount")} value={this.props.formik.values.timeSeries.employeesCount} id="employeesCount" onChange={c => this.props.formik.setFieldValue('timeSeries.employeesCount', c)} />
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default withLocalize(connectFormik(TimeSeries))


